import Int32LookupRequestListResultModel from '../../generated/types/model/resource/Int32LookupRequestListResultModel';

export default class Int32LookupRequestListResultViewModel extends Int32LookupRequestListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
